<template>
<div class="weekly-view">
	<div class="weekly-view-inner">
		<div class="days-axis">
			<div class="row-label"></div>
			<div v-for="d in week"
				class="day"
				:class="{'weekend-day': d.format('dd') == 'Su' || d.format('dd') == 'Sa'}"
				v-on:click="dayClick(d)">
				
				<div class="day-of-week">{{ d.format("ddd") }}</div>
				<div class="date">{{ d.format("MMM D") }}</div>
			</div>
		</div>

		<div class="scheduled-items">
			<div v-for="row in filterRenderedScheduleRows(renderScheduleRows(events,equipmentServicing))" 
				class="scheduled-item-row"
				:class="{
					'project-row': row.type == 'project',
					'service-row': row.type == 'service',
					'equipment-row': row.type == 'equipment-servicing'	
				}">
				<div class="row-label">
					<i class="fa mr-2 ml-2" :class="typeIcon(row.type)"
						:style="{
							'color' : row.color_hex
						}">		
					</i>
					<div>
						{{ row.description }}
						<div class="text-muted">{{getHoursScheduled(row)}} hrs scheduled</div>
					</div>
				</div>
				<div class="items-container">
					<div v-for="item in row.items" 
						class="scheduled-item"
						:class="{
							'event-continued' : eventStartToLeft(item,true) < 0
						}"
						:style="{
							left: eventStartToLeft(item)+'%',
							width: eventDurationToWidth(item)
						}"
						v-on:click="itemClick(item)">
						<i v-if="eventStartToLeft(item,true) < 0"
							class="fa fa-chevron-left mr-1"></i>

						<schedule-card-indicators 
							class="ml-1 mr-1" 
							:event-item="item"
							:selected-date="selectedDate">
						</schedule-card-indicators>
						<template v-if="daysDuration(item) > 1">
							{{item.startMoment.format("dd hh:mm A")}} - {{item.endMoment.format("dd hh:mm A")}}
						</template>
						<template v-else-if="isAllDay(item)">All Day</template>
						<template v-else>
							{{item.startMoment.format("hh:mm A")}} - {{item.endMoment.format("hh:mm A")}}
						</template>
						<br v-if="item.attachedJobDescription">
						{{item.attachedJobDescription}}
					</div>
				</div>
			</div>
		</div>
	</div>

</div>
</template>
<script type="text/javascript">

import ScheduleMixins from "@/mixins/ScheduleMixins.js"
import ScheduleCardIndicators from "@/components/schedule/ScheduleCardIndicators"

export default {
	name: "WeeklyView",
	components: {
		ScheduleCardIndicators
	},
	props: [
		"selectedDate",
		"events",
		"equipmentServicing",
		"filtering"
	],
	mixins: [ScheduleMixins],
	data() {
		return {
			projectFiltering: false,
			serviceFiltering: false,
			equipmentFiltering: false,
			userFiltering: false,
			filters: {
				mainTypes: ["project","service","equipment","user","equipment-servicing"],
				projectIds: [],
				serviceIds: [],
				equipmentIds: [],
				userIds: []
			},
			dayWidth: 100 / 7, //in %
			labelWidth: 12.5 //in %
		}
	},
	watch: {
		filtering() {
			this.initFilteringValues()
		}
	},
	computed: {
		startOfWeekMoment() {
			return this.moment(this.selectedDate).startOf("week")
		},
		week() {
			let days = []

			for (var i = 0; i < 7; i++) {
				let nextDay = this.moment(this.startOfWeekMoment).add(i,"days")
				days.push(nextDay)			
			}

			return days
		}
	},
	methods: {
		initFilteringValues() {
			let vm = this
			Object.keys(this.filtering).forEach(key => {
				vm[key] = vm.filtering[key]
			})
		},
		daysFromStartOfWeek(item) {
			return item.startMoment.diff(this.startOfWeekMoment,"days")
		},
		isAllDay(item) {
			if (item.duration >= 23.98 && item.duration <= 24)
				return true

			return false
		},
		daysDuration(item) {
			let hrsDuration = item.endMoment.diff(item.startMoment,"hours")

			return Math.ceil(hrsDuration / 24)
		},
		daysDurationToWidth(days) {
			let width = this.dayWidth * days
			return width+"%"
		},
		eventStartToLeft(item,useAbsolute) {

			let daysFromStartOfWeek = this.daysFromStartOfWeek(item)
			let left = this.dayWidth * daysFromStartOfWeek

			if (!useAbsolute && left < 0)
				left = 0		

			return left
		},
		eventDurationToWidth(item) {
			let days = this.daysDuration(item)
			let width = this.dayWidth * days

			let leftAbsolute = this.eventStartToLeft(item,true)

			if (leftAbsolute < 0)
				width += leftAbsolute //add negative left value to reduce size of event tile

			return width+"%"
		},
		getHoursScheduled(row) {
			if (!("items" in row))
				return 0

			let total = row.items.reduce((acc,item) => {
				//calc duratino in hours from start to end
				return acc + item.endMoment.diff(item.startMoment,"hours")
			},0)

			return total.toFixed(1)
		},
		dayClick(dayMoment) {
			this.$emit('dayClick',dayMoment.format("YYYY-MM-DD"))
		},
		itemClick(item) {
			this.$emit("itemClick",item)
		}
	},
	created() {
		this.initFilteringValues()
	}
}
</script>

<style type="text/css" scoped>

.scheduled-item-row.project-row .scheduled-item {
	background-color: #7c61f31c;
}

.scheduled-item-row.service-row .scheduled-item {
	background-color: #61f3af1c;
}

.weekly-view-inner {
	width: 100%;
}

.days-axis,
.scheduled-item-row {
	display: flex;
	width: 100%;
	border-bottom: 1px solid gray;
	overflow: hidden;
}

.days-axis .day {
	border-bottom: none;
	text-align: center;
	width: 12.5%;
	background-color: var(--background-menus);
	cursor: pointer;
}

.days-axis .day:hover {
	background-color: var(--brand-primary-color-translucent);
}

.days-axis .day.weekend-day {
	color: #17a2b8;
	
}

.days-axis .row-label,
.scheduled-item-row .row-label {
	width: 12.5%;
}

.scheduled-item-row .items-container {
	overflow: hidden;
	display: flex;
	position: relative;
	flex-grow: 1;
}

.scheduled-items .day {
	flex-grow: 1;
	width: 12.5%;
}

.scheduled-items .row-label {
	display: flex;
	align-items: center;
	width: 12.5%;
}

.scheduled-item-row {
	position: relative;
	min-height: 54px;
}

/*
.schedule-row.project-related-row {
	background-color: #7c61f31c;
}

.schedule-row.service-related-row {
	background-color: #61f3af1c;
}
*/

.scheduled-item {
	display: flex;
	align-items: center;
	background-color: #fff;
	border: 1px solid rgba(0,0,0,.125);
	border-radius: 4px;
	color: #495057;
	padding: 8px;
	position: static;
	width: 100%;
	background-color: var(--background-light);
	border-radius: 4px;
	font-size: 9pt;
	cursor: pointer;
	position: absolute;
	height: 100%;
	overflow: hidden;
	white-space: nowrap;
}

.scheduled-item.event-continued {
	border-left: none;
	border-top-left-radius: 0;
	border-top-right-radius: 0;
}

</style>